import React, { useState, useEffect } from "react";
import styled from "styled-components";

const StyledLink = styled.a`
  display: inline-block;
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none !important;
  padding: 0;
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const ImageLink = ({ src, href, alt, type, onClick, totalTickets }) => {
  const cacheBuster = "?v=2";
  const getImageSource = (src, type) => {
    switch (type) {
      case "googleWallet":
        return `/Site/images/icons/order-details/googleWallet.png${cacheBuster}`;
      case "appleWallet":
        return `/Site/images/icons/order-details/appleWallet.png${cacheBuster}`;
      default:
        return src;
    }
  };

  const shouldUseButton =
    totalTickets > 1 &&
    (
      (type === "googleWallet") ||
      (type === "appleWallet" && totalTickets < 11)
    );

  const linkProps =
    shouldUseButton
      ? {
          as: "button",
          type: "button",
          onClick,
        }
      : {
          href,
          target: "_self",
        };

  const imageSource = getImageSource(src, type);
  return (
    <StyledLink id={`${type}Button`} {...linkProps}>
      <StyledImage src={imageSource} alt={alt} type={type} />
    </StyledLink>
  );
};

export default ImageLink;
